import React, { useContext, useState, useEffect } from 'react';
import '../../../ui-styles/bottomSlider/BottomSlider.css';

import Checkbox from "../../../lib/ui/checkbox/Checkbox";
import { LangCtx } from "../../../lib/context";
import { saveDisableDates, getDisableDates } from "../../../actions/schedule";
import Loader from "../../../components/loading";
import {API} from 'aws-amplify';

const DisableDatesSlider = (props) => {
    const { l } = useContext(LangCtx);
    const [dis_dates, setDates] = useState([]);
    const [pos_dates, setPosDates] = useState([]);
    const [loading, setLoading] = useState(true);
    const { data } = props;
    useEffect(() => {
        // if (props.open) {
            getPosDates(props.data);
            getDisableDates().then(res => {
                setLoading(false);
                if (res.data && res.data.dates && res.data.dates.length > 0){
                    setDates([...res.data.dates]);
                }
                else {
                    setDates([]);
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err === ", err);
                setDates([]);
            })
        // }
    }, [props.data]);

    const getPosDates = (_data) => {
        let dates = [];
        for(let i = 0; i < _data.length; i++) {
            let st = new Date(_data[i].from);
            let ed = new Date(_data[i].to);
            
            while (+st <= +ed) {
                let index = _data[i].days.indexOf(st.getDay());
                if (index >= 0) dates.push(st.valueOf())
                st.setDate(st.getDate() + 1);
            }
        }
        setPosDates([...dates]);
    }

    const handleSelect = (e) => {
        let val = Number(e.target.value);
        let _dates = [...dis_dates];
        let i = _dates.indexOf(val);
        i >= 0 ? _dates.splice(i, 1) : _dates.push(val);
        setDates([..._dates]);
    }

    const handleSave = () => {
        setLoading(true);
        let body = {
            dates: [...dis_dates]
        }
        saveDisableDates(body).then(res => {
            setLoading(false);
            props.handleClose();
        }).catch(err => {
            setLoading(false);
            console.log("err === ", err);
        })
    }

    return <div className={props.open ? "btmSlider slideUp" : "btmSlider"}>
        <div className="btmSliderPaper">
            <div className="btmSliderHdr">
                <div className="btmHeaderRow">
                    <div className="hdrTxtGroup" onClick={props.handleClose}>
                        <span className="hdrBtnTxt">{l.cancel}</span>
                    </div>
                    <div className="hdrTxtGroup">
                        <span className="hdrBtnTxt" onClick={handleSave}>{l.save}</span>
                    </div>
                </div>
            </div>
            <div className="btmSliderBdy">
                {loading && <Loader />}
                {data && data.length > 0 && <div className="bsColBlock">
                    <h2 className="hdrTxtMd">{l.disable_date}</h2>
                    <p className="pTxt">{l.disable_date_txt} 
                    {/* <span className="dateTxtGroup">{new Date(data[0].from).toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })} - {new Date(data[0].to).toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>  */}
                    </p>
                </div>}

                <div className="elemtGroup">
                    {pos_dates && pos_dates.length > 0 && pos_dates.map((d, _i) => <div className="eleRow" key={`${d}_${_i}`}>
                        <Checkbox
                            onClick={handleSelect}
                            type="checkbox"
                            id={d}
                            name="disabledats"
                            value={d}
                            for={d}
                            label={new Date(d).toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                            checked={dis_dates.indexOf(d) >= 0}
                        />
                    </div>)}
                </div>
            </div>
        </div>
    </div>

}

export default DisableDatesSlider;